/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T10:19:45.936
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listCCBFinBill,
	listCCBFinBillInit,
	listCCBFinBillByAuthorizations,
	deleteCCBFinBill
	
} from '@api/house/CCBFinBill';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listCCBFinBill({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBFinBill(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCCBFinBillByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBFinBillByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCCBFinBillInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBFinBillInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteCCBFinBill({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteCCBFinBill({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
